import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import classes from "../../assets/styles/BetHistory.module.css";
import NoData from "../../utils/NoData";
import Loader from "../../utils/Loader";
import { useNavigate } from "react-router-dom";
import { getMethod } from "../../services";
import { THREE_D_BET_API } from "../../services/constant";
import Pagination from "../../utils/Pagination";
import WkThreedBetHistoryCard from "./WkThreedBetHistoryCard";

const WkThreedBetHistory = () => {
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  const groupDateByDate = (groupData) => {
    const groupedData = {};
    groupData.map((item) => {
      const date = item.created_at;
      if (!groupedData[date]) {
        groupedData[date] = [];
      }
      groupedData[date].push(item);
    });
    return groupedData;
  };

  const fetchHistory = async () => {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("b_m_a"));
    if (token) {
      const res = await getMethod(
        `${THREE_D_BET_API}?page=${page}&limit=500&type=Weekend`,
        token.token
      );
      if (res) {
        setLoading(false);
        if (res.data) {
          setHistory(groupDateByDate(res.data));
        }
        if (res.meta) {
          if (res.meta.last_page) {
            setTotalPage(res.meta.last_page);
          }
        }
      }
    } else {
      navigate("/login");
    }
  };
  useEffect(() => {
    fetchHistory();
  }, [page]);

  return (
    <>
      <div
        className={`${classes["auth-card-body"]} bg-[var(--primary-color)] rounded-lg my-3`}
      >
        <div className={classes["table-card-container"]}>
          {Object.keys(history).length > 0 ? (
            Object.keys(history).map((group_date) => (
              <WkThreedBetHistoryCard
                key={group_date}
                data={history[group_date]}
                date={group_date}
              />
            ))
          ) : (
            <NoData />
          )}
        </div>
        {totalPage > 1 && (
          <div className="flex justify-center pt-2">
            <Pagination
              setPage={setPage}
              totalPage={totalPage}
              setLoading={setLoading}
            />
          </div>
        )}
      </div>
      {ReactDOM.createPortal(
        loading && <Loader />,
        document.getElementById("portal")
      )}
    </>
  );
};

export default WkThreedBetHistory;
